import moment from 'moment';

export const formatDate = (date) => {
  if (!date) return null;

  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
};

export const formatDate2 = (date) => {
  if (!date) return null;

  const [year, month, day] = date.split('-');
  return `${year}-${month}-${day}`;
};

export const parseDate = (date) => {
  if (!date) return null;

  const [month, day, year] = date.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

export const changeFormat = (date) => {
  if (date && typeof date === 'string' && date.includes('-')) {
    const d = date.split('-');
    return `${d[2]}/${d[1]}/${d[0]}`;
  }
  return '';
};

export const reverseFormat = (date) => {
  if (date !== null) {
    const d = date.split('/');
    return `${d[2]}-${d[1]}-${d[0]}`;
  }
  return '';
};

export const addMonths = (m) => moment().add(m, 'months').format('Do MMMM YYYY');

export const diffDate = (date) => {
  const now = moment(new Date());
  return moment(date, 'YYYY-MM-DD').isBefore(now);
};

export const diffDate2 = (date) => {
  const now = moment(new Date());
  return moment(date, 'Do MMM YYYY').isBefore(now);
};

export const isInstalmentDue = (paymentSchedule) => {
  let s = false;
  if (paymentSchedule === null) return false;
  paymentSchedule.forEach((i) => {
    if (diffDate2(i.dueDate)) {
      s = true;
    }
  });
  return s;
};
